import { Drawer } from "antd";
import PropTypes from "prop-types";
import React, { ReactElement, useState } from "react";
import { useHistory, useParams } from "react-router";
import AddBtn from "../common/AddBtn";
import AddProduct from "./AddProduct";
import ProductCreateProps from "./index";
import saveAs from 'file-saver'

export interface ProductCreateProps {
  right: any;
  total: number;
  categoriesOptions: any[];
  shopsOptions: any[];
  brandsOptions: any[];
  refetch: () => void;
  setType: (val) => void;
  handleSearch: (val, field) => void;
  type?: string;
}

const TopHeading = ({
  right,
  total,
  categoriesOptions,
  shopsOptions,
  brandsOptions,
  refetch,
  setType,
  handleSearch,
  type,
}: ProductCreateProps): ReactElement => {
  const [visible, setVisible] = useState<boolean>(false);

  const route = useHistory();

  const productsDownload = (blob) => {
    saveAs(blob, `products-${Math.random().toString(36)}.xlsx`)
  }
  const onClose = () => {
    setVisible(false);
    refetch();
  };

  const dataProps = {
    categoriesOptions,
    shopsOptions,
    brandsOptions,
    onCloseMethod: onClose,
    setType,
    handleSearch,
    type,
  };

  return (
    <div className="top-heading-products top-heading-content">
      <div className="container-fluid">
        <div className="row mb-3 d-flex-sb">
          <div className="col-lg-4 col-md-4 no-padding">
            <div className="page-heading-content">
              <h2 className="d-flex-l d-flex-nowrap d-flex-base">
                <b className="nowrap" style={{ whiteSpace: "nowrap" }}>
                  Global Product List{" "}
                </b>
                <span className="d-flex-l ml-1">{total || 0} Product(s)</span>
              </h2>
            </div>
          </div>
          <div className="single-button d-flex">
            {right}
            <AddBtn
              onClick={() => {
                route.push("/global-products/add");
              }}
            />
          </div>
          <Drawer
            title="Add Product in Global"
            width={1050}
            onClose={onClose}
            visible={!!visible}
            bodyStyle={{ paddingBottom: 0 }}
            footer={
              <div
                style={{
                  textAlign: "left",
                }}
              ></div>
            }
          >
            <AddProduct {...dataProps} />
          </Drawer>
        </div>
      </div>
    </div>
  );
};

TopHeading.propTypes = {
  ProductId: PropTypes.string,
  GetStatus: PropTypes.string,
  GetPrime: PropTypes.string,
  GetFlagship: PropTypes.string,
  GetRocket: PropTypes.string,
  name: PropTypes.string,
};

export default React.memo(TopHeading);
